<div class="limiter">
  <div class="container-login100">
    <div class="wrap-login100">

      <form [formGroup]="signupForm" class="login100-form validate-form">
        <div class="Frame11"
          style="padding-left:84px; flex-direction: column; justify-content: center; align-items: center; gap: 40px; display: inline-flex">
          <div class="Frame54"
            style="align-self: stretch; height: 87px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
            <div class="Frame7"
              style="align-self: stretch; justify-content: center; align-items: flex-start; gap: 5.89px; display: inline-flex">
              <div class="Frame14"
                style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                <div class="Frame54"
                  style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 16px; display: inline-flex">
                  <div class="Frame13"
                    style="justify-content: flex-start; align-items: center; gap: 5.89px; display: flex">
                    <div class="Frame6"
                      style="padding: 11.79px; border-radius: 47.16px; border: 2.21px #05477B solid; justify-content: flex-start; align-items: flex-start; gap: 5.89px; display: flex">
                      <img style="width: 30.95px; height: 30.95px; position: relative"
                        src="../../../assets/images/luggage.png" />
                    </div>
                  </div>
                  <div class="Tourist"
                    style="color: #05477B; font-size: 56px; font-family: Roboto; font-weight: 300; line-height: 67.20px; word-wrap: break-word">
                    Tourist </div>
                </div>
                <div class="Frame4"
                  style="align-self: stretch; padding-left: 80px; justify-content: flex-start; align-items: flex-start; gap: 5.89px; display: inline-flex">
                  <div class="SimplifyYourTouristTaxToday"
                    style="color: #424242; font-size: 11.05px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 19.16px; letter-spacing: 0.34px; word-wrap: break-word">
                    Simplify Your Tourist Tax </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row recover-your-password">
            <span class="label-create-account">CREATE YOUR ACCOUNT PASSWORD</span>
          </div>

          <div class="row"
            style="align-self: stretch; flex-direction: column; justify-content: center; align-items: center; gap: 32px; display: flex">
            <div class="from-body">
              <div class="form-elements">
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>New password</mat-label>
                    <input matInput placeholder="New password" [type]="hide ? 'password' : 'text'"
                      formControlName="password" required>
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error>Password is required</mat-error>
                  </mat-form-field>
                  <app-app-password-strength [passwordToCheck]="signupForm.value.password??''"
                    (passwordStrength)="onPasswordStrengthChanged($event)"
                    style="width: 100%;"></app-app-password-strength>
                </div>
                <div class="row">
                  <mat-form-field appearance="outline">
                    <mat-label>New password confirmation</mat-label>
                    <input matInput placeholder="New password confirmation" [type]="hideC ? 'password' : 'text'"
                      formControlName="confirmPassword" required>

                    <mat-icon matSuffix (click)="hideC = !hideC">{{hideC ? 'visibility_off' : 'visibility'}}</mat-icon>

                  </mat-form-field>
                  <mat-error *ngIf="passwordMismatch">Password and confirm password fields must match.</mat-error>
                </div>
              </div>
              <div class="login-form-button">
                <button (click)="onPasswordChange()" mat-raised-button
                  [disabled]="(!this.strongPassword || !this.signupForm.valid)"
                  [ngClass]="{'button-stepper-allow': this.strongPassword && this.signupForm.valid ,'button-stepper': !this.strongPassword && !this.signupForm.valid  }">CREATE
                  PASSWORD
                  <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
                </button>
              </div>
            </div>
          </div>

        </div>
      </form>

      <div class="login100-more" style="background-image: url('../.././../assets/images/loginImage2.jpeg');">
      </div>
    </div>
  </div>
</div>